import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AmsViewPage } from '@/components/Ams/view/AmsViewPage'
import {
  amsViewSearchSchema,
  plainAmsViewSearch,
  pruneAmsViewSearch,
} from '@/components/Ams/view/search'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only. The schema and its pruning live beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/marketing/ams/')({
  validateSearch: amsViewSearchSchema,
  // VentaHub's plain query string for this route only (AmsViewPage.tsx:614-694).
  search: { middlewares: [plainAmsViewSearch] },
  component: AmsRoute,
})

function AmsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <AmsViewPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(pruneAmsViewSearch, next, options))
      }
    />
  )
}
